//
//
//
//
//
//

export default {
  name: 'sale-label',
  props: ['saleLabel', 'seatType'],
  data: function data() {
    return {
      marks: ['pre', 'yu', 'ing', 'finish', 'soldout', 'pre-will']
    };
  },
  computed: {
    saleClass: function saleClass() {
      var saleLabel;
      if (this.saleLabel === 11) {
        saleLabel = 6;
      } else {
        saleLabel = this.saleLabel;
      }
      return "i-ticket-".concat(this.marks[saleLabel - 1]);
    },
    isSeatSelectable: function isSeatSelectable() {
      return !!this.seatType && this.seatType !== 0;
    }
  }
};